import TransactionRepository from '../repositories/TransactionRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';

export interface ITransactionLoad {
  transactionLoadOptions: ITransactionLoadOptions;
}

interface ITransactionLoadOptions {
  isEnabled?: boolean;
  isControlled?: boolean;
  shouldAwait?: boolean;
}

// Every use case extending this, will have the reloading transaction option enabled
const defaultOptions: ITransactionLoadOptions = {
  // let the concrete class define when to load the transaction
  isControlled: false,
  // enable transaction reloading
  isEnabled: true,
  // await for transaction reloading after use case execution
  shouldAwait: false,
};

// This abstract class is intentend to be used with use cases that requires transaction updates
// It helps encapsulating details needed to control a transaction reload
export default abstract class TransactionLoadHandler {

  private options: ITransactionLoadOptions;

  protected transactionRepository: TransactionRepository;

  constructor(options: ITransactionLoadOptions = defaultOptions) {
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
    this.options = { ...defaultOptions, ...options };
  }

  protected abstract run(): Promise<void>;

  async handleTransactionUpdate(): Promise<void> {
    const {
      isEnabled,
      shouldAwait,
    } = this.options;
    if (isEnabled && this.transactionRepository.transaction.isDirty) {
      if (shouldAwait) {
        await this.transactionRepository.loadTransaction();
      } else {
        this.transactionRepository.loadTransaction();
      }
    }
  }

  async execute(): Promise<void> {
    await this.run();
    if (!this.options.isControlled) {
      await this.handleTransactionUpdate();
    }
  }
}